import { configureStore } from '@reduxjs/toolkit';

const store = configureStore({
  reducer: {
    // 可以在需要时添加reducer
  }
});

export default store; 